import React from 'react';
import { createIcon } from '@chakra-ui/react';

const LogoSAC = createIcon({
  displayName: 'LogoSAC',
  viewBox: '0 0 280.44 281.76',
  path: (
    <g transform="translate(-128.94 -7.8628)" fillRule="evenodd">
      <path d="m369.19 46.996c-13.996-4.9727-26.449 5.9492-22.578 18.809 13.336 44.297 4.9024 81.527-14.113 114.72-3.0938 5.4023 0.13282 7.7031 3.7656 6.1133 20.172-8.8242 49.531-29.461 66.324-58.301 12.969-22.266 10.211-65.855-33.398-81.34" />
      <path d="m329.67 98.246c-1.4844-19.719-10.266-50.742-29.766-73.574-15.055-17.629-52.922-28.309-79.09 4-8.3984 10.367-2.832 24.172 9.25 24.734 41.625 1.9336 70.75 20.191 93.289 46.203 3.668 4.2344 6.5859 2.1914 6.3164-1.3633" />
      <path d="m254.38 81.242c-20.887-5.9922-56.457-9.4492-88.094 0.09375-24.43 7.3711-51.277 38.484-29.039 74.816 7.1367 11.664 23.66 11.664 29.301 0.67578 19.434-37.871 50.402-58.047 86.586-69.219 5.8867-1.8203 5.0078-5.2852 1.2461-6.3672" />
      <path d="m264.65 257.26c-37.75-36.73-49.977-78.449-49.453-122 0.082-7.0859-4.3906-7.5938-7.1211-4.0039-15.148 19.938-32.887 56.703-33.613 94.695-0.55859 29.328 26.297 71.195 78.168 62.508 16.648-2.7891 22.973-20.539 12.02-31.199" />
    </g>
  ),
});

export default LogoSAC;
